module.exports = __webpack_public_path__ + "static/media/chatListPlaceholder.1128a5c4.svg";